<template>
  <div>
    <v-icon dense :color="onDarkBackground ? 'white' : 'black'">mdi-account</v-icon>
    <span class="mr-3" :class="onDarkBackground ? 'text-white' : 'text-black'">{{ username }}</span>
    <v-btn
      style="border: solid 1px;"
      flat
      :color="onDarkBackground ? 'primary' : 'secondary'"
      small
      @click="logOut"
    >
      {{ t('auth.logOut.btn') }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/store/modules/auth'
import { storeToRefs } from 'pinia'

const { t } = useI18n()
const { username } = storeToRefs(useAuthStore())

defineProps<{ onDarkBackground: boolean }>()

function logOut() {
  useAuthStore().logOutUser()
}
</script>
